import {
    Application,
    ApplicationContact,
    ApplicationBiometry,
    ApplicationDocument,
    ApplicationApplicant,
    ApplicationContactAddress,
    ApplicationDocumentDelivery,
    ApplicationAuthorizedPerson,
    CourierDelivery
} from '@/commons/types'

export class CourierDeliveryEntity implements CourierDelivery {
    country = null
    city = null
    postalCode = null
}
export class ApplicationDocumentDeliveryEntity implements ApplicationDocumentDelivery {
    type = null
    location = null
    courier = null
}

export class ApplicationAuthorizedPersonEntity implements ApplicationAuthorizedPerson {
    firstName = null
    lastName = null
    personCode = null
}

export class ApplicationDocumentEntity implements ApplicationDocument {
    reason = null
    expedited = false
    delivery = new ApplicationDocumentDeliveryEntity()
    reasonExplanation = null
    isWithAuthorized = false
    authorizedPerson = null
}

export class ApplicationApplicantEntity implements ApplicationApplicant {
    personCode = null
    birthCountry = null
    disabled = false
    education = null
    nationality = null
    nativeLanguage = null
}

export class ApplicationContactEntity implements ApplicationContact {
    email = null
    address: ApplicationContactAddress = {
        city: null,
        adsOid: null,
        street: null,
        country: null,
        adsAdrId: null,
        postalCode: null,
        fullAddress: null,
        stateOrProvinceOrCounty: null,
        notes: null
    }

    phoneNumber = null
}

export class ApplicationBiometryEntity implements ApplicationBiometry {
    photo = null
    signature = null
}

export class ApplicationEntity implements Application {
    uuid = undefined
    confirmedConditions = false
    confirmedValidDocumentForCourier = false
    contact = new ApplicationContactEntity()
    biometry = new ApplicationBiometryEntity()
    applicant = new ApplicationApplicantEntity()
    idCard = new ApplicationDocumentEntity()
    citizenPassport = new ApplicationDocumentEntity()
}

export class Address {
    adsId: number | null = null;
    adsCode = '';
    fullAddress = '';
    postalCode: number | null = null;

    constructor (adsId: number | null, adsCode: string, fullAddress: string, postalCode: number | null) {
        this.adsId = adsId
        this.adsCode = adsCode
        this.fullAddress = fullAddress
        this.postalCode = postalCode
    }
}
